<ngx-slider
  *ngIf="renderSlider"
  class="map-time-bar-slider"
  [value]="currentValue"
  (valueChange)="onValueChange($event)"
  [options]="options"
></ngx-slider>
